// src/components/Header.jsx
import { Link } from "react-router-dom";
import styles from "./Header.module.css";

function Header() {
  return (
    <header className={styles.header}>
      <nav className={styles.navContainer}>
        <Link to="/" className={styles.siteTitle}>
          The Rhatigans (& fam!)
        </Link>
        <div className={styles.navLinks}>
          <Link to="/" className={styles.navLink}>
            Home
          </Link>
          <Link to="/photos" className={styles.navLink}>
            Photos
          </Link>
          <Link to="/videos" className={styles.navLink}>
            Videos
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Header;
